const MILESTONE_MESSAGES: Record<number, string> = {
  100: "Not Bad for a Fat Boy",
  250: "Still Running?!",
  500: "God Mode",
  1000: "Touch Grass",
  1500: "Bruh Moment",
  2000: "You Need Help",
  3000: "Built Different",
  5000: "No Life Energy",
};

const DEATH_MESSAGES = [
  "You Got Clapped",
  "Skill Issue",
  "Back to the Fryer",
  "L + Ratio",
  "Thoughts and Prayers",
  "Should've Ducked",
  "Caught in 4K",
  "RIP Bozo",
  "Packed Up",
  "Get Good",
  "Finished",
  "Down Bad",
];

export class Score {
  distance = 0;
  bonus = 0;
  best = 0;
  private lastMilestone = 0;
  lastMilestoneMsg = "";

  constructor() {
    this.best = Number(localStorage.getItem("exorunner_best") ?? 0) || 0;
  }

  get total(): number {
    return Math.floor(this.distance + this.bonus);
  }

  addDistance(px: number): void {
    this.distance += px * 0.05;
  }

  addBonus(n: number): void {
    this.bonus += n;
  }

  /** Returns true when a new 100-point milestone is crossed */
  checkMilestone(): boolean {
    const m = Math.floor(this.total / 100);
    if (m > this.lastMilestone) {
      this.lastMilestone = m;
      const msg = MILESTONE_MESSAGES[this.total - (this.total % 100)];
      if (msg) this.lastMilestoneMsg = msg;
      return true;
    }
    return false;
  }

  getMilestoneMessage(): string {
    return this.lastMilestoneMsg;
  }

  getDeathMessage(): string {
    return DEATH_MESSAGES[Math.floor(Math.random() * DEATH_MESSAGES.length)];
  }

  reset(): void {
    this.distance = 0;
    this.bonus = 0;
    this.lastMilestone = 0;
    this.lastMilestoneMsg = "";
  }

  commitBest(): number {
    const t = this.total;
    if (t > this.best) {
      this.best = t;
      localStorage.setItem("exorunner_best", String(t));
    }
    return t;
  }
}
